import { Grid } from '@mui/material'
import { CropPhaseChips } from './crop-phase-chips'
import { CropTypeToggles } from './crop-type-toggles'

export const CropScheduleControls = ({
  cropPhaseTypes,
  cropGrowthTypes,
  cropLifecycleTypes,
  availableCropPropagationTypes,
  effectivePhaseCodes,
  activePropagationCode,
  handlers,
}) => {
  const { handlePhaseToggle, handleGrowthTypeChange, handleLifecycleTypeChange } = handlers

  const handlePropagationChange = (newValue) => {
    handlers.handlePropagationChange?.(newValue)
  }

  return (
    <Grid container spacing='1rem' rowSpacing='0.25rem' direction='row-reverse'>
      <Grid
        size={{ xs: 12, sm: 5 }}
        justifyItems={{ xs: 'center', sm: 'flex-end' }}
        sx={{ display: 'grid', alignContent: 'flex-end', mb: { xs: 0, sm: 1 } }}
      >
        <CropTypeToggles
          availableCropPropagationTypes={availableCropPropagationTypes}
          cropLifecycleTypes={cropLifecycleTypes}
          cropGrowthTypes={cropGrowthTypes}
          activePropagationCode={activePropagationCode}
          onPropagationChange={handlePropagationChange}
          onLifecycleChange={handleLifecycleTypeChange}
          onGrowthChange={handleGrowthTypeChange}
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 7 }} alignContent='flex-end'>
        <CropPhaseChips
          cropPhaseTypes={cropPhaseTypes}
          effectivePhaseCodes={effectivePhaseCodes}
          activePropagationCode={activePropagationCode}
          onPhaseToggle={handlePhaseToggle}
        />
      </Grid>
    </Grid>
  )
}
